<template>
  <section class="logo">
    <a
      class="logo__link"
      :href="`/${$store.state.lang}`"
      @click.prevent="$goTo(`/${$store.state.lang}`, 'logo');"
      v-if="$route.name !== 'index' && $route.name !== 'error404'"
      aria-label="Pygar"
    >
      <slot name="logo" />
    </a>
    <div
      v-else
    >
      <slot name="logo" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Logo',
}
</script>

<style lang="scss" scoped>
.logo {
  position: relative;
  grid-area: a;

  @include mq(ipadP) {
    grid-area: b;
  }

  & > * {
    display: inline-block;
    pointer-events: auto;
  }
}
</style>
